import React, { useEffect, useRef, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { CSVLink } from "react-csv";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { connect } from "react-redux";
import MakeAPICall from "../../apiCalls/common";

import {
  blockedDoctorsApiRoute,
  blockPatientApiRoute,
  deletePatientApiRoute,
  exportDataApiRoute,
  getPatientListApiRoute,
  getPatientListWithFiltersApiRoute,
  sendPatNotificationApiRoute
} from "../../apiRoutes";

import { converToUtc, getFormattedDate, getFormattedTime } from "../../utils/dateTimeHelper";
import { csUndefined, sortData } from "../../utils/commonMethods";

import Button from "../../components/button";
import CustomModal from "../../components/modal";

import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";
import SendNotificationForm from "../../containers/PatientsForms/sendNotificationForm";
import PatientProfileForm from "../../containers/PatientsForms/patientProfileForm";
import ViewProfilePic from "../../components/viewProfilePic";
import PatientBlockedDoctors from "../../containers/PatientsForms/patientBlockedDoctors";

import ICNoImg from "../../assets/images/default-picture.png";
import { STATE_LIST } from "../../constants/constants";
import Label from "../../components/label";
import APP_CONSTANTS from "../../constants";
import ICSelect from "../../components/form/selectInput";

const INCOMPLETE_PROFILE_FILTERS = [
  { _id: "IC", val: "Instant Consult Patients" },
  { _id: "IS", val: "Incomplete Instant Extras Only" }
];

const PatientsPage = props => {
  const csvDownRef = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams1, setApiCallParams1] = useState(null);
  const [apiCallParams2, setApiCallParams2] = useState(null);
  const [blockedDoctorsList, setBlockDoctorsList] = useState([]);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [patientsList, setPatientsList] = useState([]);
  const [filterBlock, setFilterBlock] = useState("none");
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [currSelPat, setCurrSelPat] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showUnblockModal, setShowUnblockModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSendNotificationModal, setShowSendNotificationModal] = useState(
    false
  );
  const [showViewProfilePicModal, setShowViewProfilePicModal] = useState(false);
  const [showBlockedDocModal, setShowBlockedDocModal] = useState(false);
  const [showSuccModal, setShowSuccModal] = useState(false);
  const [succModalText, setSuccModalText] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");
  const [incompleteProfileFilter, setIncompleteProfileFilter] = useState("IC");

  const tableHeaders = [
    {
      key: "patientId",
      value: "UIN",
      customStyle: { width: "110px" }
    },
    { key: "profilePicOri", value: "Profile Pic" },
    { key: "fullName", value: "Patient Details" },
    { key: "dateOfBirth", value: "DOB", customStyle: { width: "110px" } },
    { key: "gender", value: "Gender" },
    { key: "action", value: "Action" }
  ];

  let excelSheetHeader = [
    { label: "UIN", key: "UIN" },
    { label: "Profile Pic", key: "Profile_Pic" },
    { label: "First Name", key: "First_Name" },
    { label: "Middle Name", key: "Middle_Name" },
    { label: "Last Name", key: "Last_Name" },
    { label: "Date of Birth", key: "Date_of_Birth" },
    { label: "Gender", key: "Gender" },
    { label: "Email Address", key: "Email_Address" },
    { label: "Mobile Number", key: "Mobile_Number" },
    { label: "Unit Number", key: "UnitNumber" },
    { label: "Street Number", key: "Street_Number" },
    { label: "Street Name", key: "Street_Name" },
    { label: "Suburb", key: "Suburb" },
    { label: "State", key: "State" },
    { label: "Postcode", key: "Postcode" },
    { label: "Medicare Number", key: "Medicare_Number" },
    { label: "Reference Number", key: "Reference_Number" },
    { label: "Medicare Verification", key: "Medicare_Verification" },
    { label: "IHI Number", key: "IHI_Number" },
    { label: "IHI IHIRecordStatus", key: "IHI_IHIRecordStatus" },
    { label: "IHI IHINumberStatus", key: "IHI_IHINumberStatus" },
    { label: "Device Type", key: "deviceType" },
    { label: "Consulted Count", key: "consultedCount" },
    { label: "Emergency Contact Name 1", key: "Emergency_Contact_Name_1" },
    { label: "Emergency Contact Number 1", key: "Emergency_Contact_Number_1" },
    { label: "Emergency Contact Name 2", key: "Emergency_Contact_Name_2" },
    { label: "Emergency Contact Number 2", key: "Emergency_Contact_Number_2" },
    { label: "Default Credit Card Number", key: "Default_Credit_Card_Number" },
    { label: "Registration Date", key: "Registration_Date" },
    { label: "Registration Time", key: "Registration_Time" },
    {
      label: "Additional Notes Regarding This Patient",
      key: "Additional_Notes_Regarding_This_Patient"
    },
    {
      label: "Successful Marketing Source",
      key: "Successful_Marketing_Source"
    },
    { label: "Status", key: "Status" },
    {
      label: "OptOutMarketing",
      key: "optOutMarketingEmails"
    }
  ];

  const handleBlockedFilterChange = e => {
    if (e.target.value === "none") {
      setFilterBlock("none");
    } else {
      setFilterBlock(e.target.value);
    }
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, patientsList);
    setPatientsList(sortedData);
  };

  // gets patients list
  const getPatientsList = () => {
    setIsProcessing(true);

    let api = getPatientListApiRoute;
    let filters = Object.assign({}, currFilters);

    if (currFilters.text && currFilters.text.trim().length > 0) {
      api = getPatientListWithFiltersApiRoute;
    } else {
      delete filters.text;
    }

    if (filterBlock !== "none") {
      filters.isBlocked = filterBlock;
    }

    switch (incompleteProfileFilter) {
      case "IS": filters["isISPatientOnly"] = true; break;
      case "IH": filters["isIHPatientOnly"] = true; break;
    }

    setApiCallParams1({
      reqType: "GET",
      reqUrl: api,
      params: filters,
      successCallback: async res => {
        let list = [];

        console.log("Got the list data: ", res.data.data);

        await res.data.data.patients.forEach(column => {
          let d = {};

          d._id = column._id;
          if (column.patientId) {
            d.patientId = column.patientId;
          } else {
            d.patientId = "";
          }
          d.gender = column.gender;
          d.profilePicOri =
            column.profilePic === null ||
            column.profilePic === undefined ||
            column.profilePic === ""
              ? ICNoImg
              : column.profilePic.original;
          d.refNumerOnMedicareCard = column.refNumerOnMedicareCard;
          d.medicareNumber = column.medicareNumber;
          d.postCode = column.address.postCode;
          d.state = column.address.state;
          d.suburb = column.address.suburb;
          d.streetName = column.address.streetName;
          d.streetNumber =
            column.address.unitNumber === null ||
            column.address.unitNumber === undefined ||
            column.address.unitNumber === ""
              ? column.address.streetNumber
              : column.address.unitNumber + "/" + column.address.streetNumber;
          d.unitNumber =
            column.unitNumber !== null ||
            column.unitNumber !== "undefined" ||
            column.unitNumber !== ""
              ? ""
              : column.unitNumber;

          d.phoneNumber = column.phoneNumber || "";
          d.dateOfBirth = column.dateOfBirth;
          d.email = column.email;
          d.lastName = column.lastName;
          d.middleName =
            column.middleName === null ||
            column.middleName === undefined ||
            column.middleName === ""
              ? ""
              : column.middleName;
          d.firstName = column.firstName;
          d.firstNameForHIService = column.firstNameForHIService;
          d.lastNameForHIService = column.lastNameForHIService;

          d.fullName = column.firstName + " ";

          if (
            column.middleName !== null &&
            column.middleName !== undefined &&
            column.middleName !== ""
          ) {
            d.fullName = d.fullName + column.middleName + " ";
          }

          d.fullName = d.fullName + column.lastName;

          if (column.kin1) {
            d.contactName =
              column.kin1.name === "" ||
              column.kin1.name === null ||
              column.kin1.name === undefined
                ? ""
                : column.kin1.name;
            if (
              column.kin1.contact === "" ||
              column.kin1.contact === null ||
              column.kin1.contact === undefined
            ) {
              d.contactContact = "";
            } else {
              d.contactContact = column.kin1.contact;
            }
          } else {
            d.contactName = "";
            d.contactContact = "";
          }
          if (column.kin2) {
            d.contactName2 =
              column.kin2.name === "" ||
              column.kin2.name === null ||
              column.kin2.name === undefined
                ? ""
                : column.kin2.name;
            if (
              column.kin2.contact === "" ||
              column.kin2.contact === null ||
              column.kin2.contact === undefined
            ) {
              d.contactContact2 = "";
            } else {
              d.contactContact2 = column.kin2.contact;
            }
          } else {
            d.contactName2 = "";
            d.contactContact2 = "";
          }
          if (column.additionalInfo) {
            d.additionalInfo = column.additionalInfo;
          } else {
            d.additionalInfo = " ";
          }
          d.isBlocked = column.isBlocked;
          d.registrationDate =
            csUndefined(getFormattedDate(column.createdAt)) +
            " " +
            csUndefined(getFormattedTime(column.createdAt));

          if (
            column.patientCards &&
            column.patientCards !== undefined &&
            column.patientCards !== null
          ) {
            if (Array.isArray(column.patientCards) === true) {
              if (
                column.patientCards.length > 0 &&
                column.patientCards[0] !== null &&
                column.patientCards[0] !== undefined
              ) {
                d.patientCards = column.patientCards;
              } else {
                d.patientCards = [];
              }
            } else if (column.patientCards.lastFourDigit) {
              d.patientCards = [column.patientCards];
            } else {
              d.patientCards = [];
            }
          } else {
            d.patientCards = [];
          }

          d.verificationByMedicareOnlineCode =
            column.verificationByMedicareOnlineCode;
          d.verificationByMedicareOnlineUpdatedAt =
            column.verificationByMedicareOnlineUpdatedAt;
          d.IHIInfo = column.IHIInfo;
          d.optOutMarketingEmails =
            column.optOutMarketingEmails === true ? true : false;
          // d.DVANumber = column.DVANumber;

          d.isDependent = column.isDependent === true ? true : false;
          d.dependents = column.dependents ? column.dependents : [];
          d.parentId = column.parentId ? column.parentId : null;

          d.isInstantSwitchOnly = column.isInstantSwitchOnly || false;
          d.isPatientRequestToDeleteAC = column.isPatientRequestToDeleteAC || false;

          list.push(d);
        });

        setPatientsList(list);
        setTotalRecords(res.data.data.count);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // export patient data
  const exportPatData = e => {
    e.preventDefault();

    setIsProcessing(true);
    var formData = new FormData();
    formData.append("who", "patient");

    if (startDate !== null && endDate !== null && startDate <= endDate) {
      formData.append("startDate", converToUtc(startDate));
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();
      formData.append("endDate", converToUtc(dt));
    }

    // Todo formData.append("isISPatientOnly", isISPatientOnly);

    switch (incompleteProfileFilter) {
      case "IS": formData.append("isISPatientOnly", true); break;
      case "IH": formData.append("isIHPatientOnly", true); break;
    }

    setApiCallParams1({
      reqType: "POST",
      reqUrl: exportDataApiRoute,
      dataObj: formData,
      successCallback: async res => {
        var excelArray = [];
        await res.data.data.forEach(function(column) {
          var e = {};
          if (column.patientId) {
            e.UIN = column.patientId;
          } else {
            e.UIN = "";
          }
          e.Profile_Pic =
            column.profilePic === null ||
            column.profilePic === undefined ||
            column.profilePic === ""
              ? ICNoImg
              : column.profilePic.original;
          e.First_Name = csUndefined(column.firstName);
          e.Middle_Name =
            column.middleName === null ||
            column.middleName === undefined ||
            column.middleName === ""
              ? ""
              : csUndefined(column.middleName);
          e.Last_Name = csUndefined(column.lastName);
          e.Date_of_Birth = csUndefined(column.dateOfBirth);
          e.Gender = csUndefined(column.gender);
          e.Email_Address = csUndefined(column.email);
          e.Mobile_Number = csUndefined(column.phoneNumber);
          e.UnitNumber =
            column.address.unitNumber === null ||
            column.address.unitNumber === undefined ||
            column.address.unitNumber === ""
              ? ""
              : csUndefined(column.address.unitNumber);
          e.Street_Number = csUndefined(column.address.streetNumber);
          e.Street_Name = csUndefined(column.address.streetName);
          e.Suburb = csUndefined(column.address.suburb);
          e.State = column.address.state;
          e.Postcode = column.address.postCode;
          e.Medicare_Number = csUndefined(column.medicareNumber);
          e.Reference_Number = csUndefined(column.refNumerOnMedicareCard);
          e.Medicare_Verification = csUndefined(
            column.verificationByMedicareOnlineStatus
              ? column.verificationByMedicareOnlineStatus
              : ""
          );
          e.IHI_Number = csUndefined(
            column.IHIInfo
              ? column.IHIInfo.IHINumber
                ? column.IHIInfo.IHINumber
                : ""
              : ""
          );
          e.IHI_IHIRecordStatus = csUndefined(
            column.IHIInfo
              ? column.IHIInfo.IHIRecordStatus
                ? column.IHIInfo.IHIRecordStatus
                : ""
              : ""
          );
          e.IHI_IHINumberStatus = csUndefined(
            column.IHIInfo
              ? column.IHIInfo.IHINumberStatus
                ? column.IHIInfo.IHINumberStatus
                : ""
              : ""
          );
          e.deviceType = csUndefined(
            column.deviceDetails
              ? column.deviceDetails.deviceType
                ? column.deviceDetails.deviceType
                : ""
              : ""
          );
          e.consultedCount = column.consultedBy
            ? column.consultedBy.length
              ? column.consultedBy.length
              : "0"
            : "";
          if (column.kin1) {
            e.Emergency_Contact_Name_1 =
              column.kin1.name === "" ||
              column.kin1.name === null ||
              column.kin1.name === undefined
                ? ""
                : csUndefined(column.kin1.name);
            e.Emergency_Contact_Number_1 =
              column.kin1.contact === "" ||
              column.kin1.contact === null ||
              column.kin1.contact === undefined
                ? ""
                : csUndefined(column.kin1.contact);
          } else {
            e.Emergency_Contact_Name_1 = "";
            e.Emergency_Contact_Number_1 = "";
          }
          if (column.kin2) {
            e.Emergency_Contact_Name_2 =
              column.kin2.name === "" ||
              column.kin2.name === null ||
              column.kin2.name === undefined
                ? ""
                : csUndefined(column.kin2.name);
            e.Emergency_Contact_Number_2 =
              column.kin2.contact === "" ||
              column.kin2.contact === null ||
              column.kin2.contact === undefined
                ? ""
                : csUndefined(column.kin2.contact);
          } else {
            e.Emergency_Contact_Name_2 = "";
            e.Emergency_Contact_Number_2 = "";
          }
          if (
            column.patientCards &&
            column.patientCards !== undefined &&
            column.patientCards !== null
          ) {
            if (Array.isArray(column.patientCards) === true) {
              if (
                column.patientCards.length > 0 &&
                column.patientCards[0] !== null &&
                column.patientCards[0] !== undefined
              ) {
                e.Default_Credit_Card_Number =
                  column.patientCards[0].lastFourDigit;
              } else {
                e.Default_Credit_Card_Number = "";
              }
            } else if (column.patientCards.lastFourDigit) {
              e.Default_Credit_Card_Number = column.patientCards.lastFourDigit;
            } else {
              e.Default_Credit_Card_Number = "";
            }
          } else {
            e.Default_Credit_Card_Number = "";
          }

          e.Registration_Date = csUndefined(getFormattedDate(column.createdAt));
          e.Registration_Time = csUndefined(getFormattedTime(column.createdAt));
          if (column.additionalInfo) {
            var someText = column.additionalInfo;
            var match = /\r|\n/.exec(someText);
            if (match) {
              var someText1 = someText.replace(/(\r\n|\n|\r)/gm, " ");
              e.Additional_Notes_Regarding_This_Patient = csUndefined(
                someText1
              );
            } else {
              e.Additional_Notes_Regarding_This_Patient = csUndefined(
                column.additionalInfo
              );
            }
          } else {
            e.Additional_Notes_Regarding_This_Patient = "";
          }

          // added below due to \" creating problem in generating csv file
          let hereAboutUs = column.whereDidYouHearAboutUs || column.marketing || "";
          hereAboutUs = hereAboutUs.replace(/\"/g, "'");
          e.Successful_Marketing_Source = csUndefined(hereAboutUs);

          // e.Successful_Marketing_Source = column.whereDidYouHearAboutUs
          //   ? csUndefined(column.whereDidYouHearAboutUs)
          //   : "";
          e.Status = column.isBlocked === false ? "Unblocked" : "Blocked";

          // opt out marketing
          e.optOutMarketingEmails =
            column.optOutMarketingEmails === true ? 'Y' : '';

          excelArray.push(e);
        });

        setExcelSheetData(excelArray);
        setIsProcessing(false);

        // after setting the excel sheet data trigger the csv download component click event
        csvDownRef.current.link.click();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // unblock patient
  const unblockSelPat = () => {
    setShowUnblockModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("patient_id", currSelPat._id);
    formData.append("isBlocked", false);

    setApiCallParams1({
      reqType: "PUT",
      reqUrl: blockPatientApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Patient Unblocked Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // block patient
  const blockSelPat = () => {
    setShowBlockModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("patient_id", currSelPat._id);
    formData.append("isBlocked", true);

    setApiCallParams1({
      reqType: "PUT",
      reqUrl: blockPatientApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Patient Blocked Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // delete selected patient
  const deleteCurrSelPat = () => {
    setShowDeleteModal(false);
    setIsProcessing(true);

    setApiCallParams1({
      reqType: "DELETE",
      reqUrl: deletePatientApiRoute + currSelPat._id,
      successCallback: async res => {
        setIsProcessing(false);
        setSuccModalText("Patient Deleted Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // send patient notification
  const sendPatNotification = msg => {
    setShowSendNotificationModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("patientId", currSelPat._id);
    formData.append("message", msg);
    formData.append("user", "Patient");
    formData.append("fromWhere", "patient");
    formData.append("isSMS", true);
    formData.append("isEmail", true);
    formData.append("isPushNotification", true);

    setApiCallParams1({
      reqType: "POST",
      reqUrl: sendPatNotificationApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Notification Sent To Patient Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // get patient blocked doctors list
  const getBlockedDoctors = async pat => {
    setIsProcessing(true);

    let parms = {
      patientId: pat._id,
      skip: 0,
      limit: 0
    };

    await setApiCallParams1({
      reqType: "GET",
      reqUrl: blockedDoctorsApiRoute,
      params: parms,
      successCallback: res => {
        setIsProcessing(false);
        setBlockDoctorsList(res.data.data);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getPatientsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters, filterBlock]);

  useEffect(() => {
    getPatientsList();
  }, [incompleteProfileFilter]);

  const viewProfileForm = pat => {
    console.log("Open patient profile: ", pat);
    if (incompleteProfileFilter==="IC") {
      setCurrSelPat(pat);
      setShowProfileModal(true);
    }
  };

  const viewProfilePic = pat => {
    setCurrSelPat(pat);
    setShowViewProfilePicModal(true);
  };

  const viewPatBlockedDoc = pat => {
    setCurrSelPat(pat);
    getBlockedDoctors(pat);
    setShowBlockedDocModal(true);
  };

  const sendNotification = pat => {
    setCurrSelPat(pat);
    setShowSendNotificationModal(true);
  };

  const unblockPat = pat => {
    setCurrSelPat(pat);
    setShowUnblockModal(true);
  };

  const blockPat = pat => {
    setCurrSelPat(pat);
    setShowBlockModal(true);
  };

  const deletePat = pat => {
    setCurrSelPat(pat);
    setShowDeleteModal(true);
  };

  const patEditSuccess = () => {
    setShowProfileModal(false);
    setSuccModalText("Patient's Profile Updated Successfully");
    setShowSuccModal(true);
  };

  const handleStartDateChange = date => {
    setStartDate(date);
  };

  const handleEndDateChange = date => {
    setEndDate(date);
  };

  const clearFilter = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const openPMS = (patientId, e) => {
    e.stopPropagation();
    const auth = props.auth.user;
    window.open(
      APP_CONSTANTS.pmsURL +
      "/patient/patientDetails?accessToken=" +
      auth.accessToken +
      "&patientId=" +
      patientId +
      "&searchType=" +
      auth.userType +
      "&adminName=" +
      auth.firstName +
      " " +
      auth.lastName,
      "_blank"
    );
  };

  return (
    <div className="view-ticket-container logins-page-container">
      <CustomModal
        className="modal-lg"
        openModal={showProfileModal}
        cancelEvent={() => {
          setShowProfileModal(false);
          setCurrSelPat(null);
        }}
        title={<span>Patient Profile</span>}
        modalBodyContent={
          <PatientProfileForm
            statesList={STATE_LIST}
            data={currSelPat}
            successEvent={patEditSuccess}
          />
        }
        noFooterButtons={true}
        backdrop="static"
      />
      <CustomModal
        className="modal-lg"
        openModal={showBlockedDocModal}
        cancelEvent={() => {
          setShowBlockedDocModal(false);
          setCurrSelPat(null);
          setBlockDoctorsList([]);
        }}
        title="Block Doctors"
        modalBodyContent={
          <PatientBlockedDoctors blockedDoctors={blockedDoctorsList} />
        }
        useOneButton={true}
        cancelText="Close"
      />
      <CustomModal
        openModal={showViewProfilePicModal}
        cancelEvent={() => {
          setShowViewProfilePicModal(false);
          setCurrSelPat(null);
        }}
        title="View Profile Pic"
        modalBodyContent={
          <ViewProfilePic
            profileImg={
              currSelPat !== null ? currSelPat.profilePicOri : ICNoImg
            }
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        openModal={showSendNotificationModal}
        cancelEvent={() => {
          setShowSendNotificationModal(false);
          setCurrSelPat(null);
        }}
        title="Send Notification"
        modalBodyContent={
          <SendNotificationForm
            onFormSubmit={sendPatNotification}
            isPatient={true}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showUnblockModal}
        cancelEvent={() => {
          setShowUnblockModal(false);
          setCurrSelPat(null);
        }}
        okayEvent={unblockSelPat}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to unblock this patient?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showBlockModal}
        cancelEvent={() => {
          setShowBlockModal(false);
          setCurrSelPat(null);
        }}
        okayEvent={blockSelPat}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to block this patient?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDeleteModal}
        cancelEvent={() => {
          setShowDeleteModal(false);
          setCurrSelPat(null);
        }}
        okayEvent={deleteCurrSelPat}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this patient?
          </p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
          setCurrSelPat(null);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccModal}
        cancelEvent={() => {
          setShowSuccModal(false);
          setSuccModalText("");
          setCurrSelPat(null);
          getPatientsList();
        }}
        modalBodyContent={<p className="text-center mb-0">{succModalText}</p>}
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <div>
            <h3>Patients</h3>
            <div>
              <ICSelect
                label=""
                id="incomplete-profile-filter"
                items={INCOMPLETE_PROFILE_FILTERS}
                useId="_id"
                useValue="val"
                value={incompleteProfileFilter}
                // handleChange={val => (formik.values.year = val)}
                handleChange={val => {
                  setIncompleteProfileFilter(val);
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-row align-items-end">
            <KeyboardDatePicker
              name="startDate"
              style={{ width: "135px" }}
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="Start Date"
              value={startDate}
              onChange={date => handleStartDateChange(date)}
            />
            <KeyboardDatePicker
              name="endDate"
              style={{ width: "135px", marginLeft: "20px" }}
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="End Date"
              value={endDate}
              onChange={date => handleEndDateChange(date)}
            />
            {startDate !== null && endDate !== null && (
              <button
                style={{ minWidth: "30px", width: "30px" }}
                className="insta-button-primary ic-btn-red ml-3"
                onClick={clearFilter}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField
              select
              SelectProps={{
                native: true
              }}
              onChange={handleBlockedFilterChange}
              value={filterBlock}
            >
              <option value="none">Select Blocked Status</option>
              <option value="false">Unblocked</option>
              <option value="true">Blocked</option>
            </TextField>
            {filterBlock !== "none" && (
              <button
                style={{ minWidth: "30px", width: "30px" }}
                className="insta-button-primary ic-btn-red ml-3"
                onClick={() => {
                  setFilterBlock("none");
                }}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button clickEvent={exportPatData} title="Export to CSV"></Button>
            <CSVLink
              style={{ display: "none" }}
              ref={csvDownRef}
              className="no-text-decoration"
              filename={"Patient_List.csv"}
              data={excelSheetData}
              headers={excelSheetHeader}
            ></CSVLink>
          </div>
        </div>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
          disbleAll={true}
        >
          {patientsList.length > 0 &&
            patientsList.map((patient, index) => (
              <tr className={`${patient.isPatientRequestToDeleteAC ? 'patient-deleted-ac-bg' : ''}`} onClick={() => viewProfileForm(patient)} key={index}>
                <td className={incompleteProfileFilter==="IC"?"cursor-pointer":""} onClick={(e) => {
                  if (incompleteProfileFilter==="IC") {
                    openPMS(patient._id, e);
                  }
                }}><Label title={patient.patientId}
                          className={`w-auto font-12 mb-0 secondary-font cursor-pointer ${patient.uinColor}`}></Label>
                </td>

                <td
                  onClick={e => {
                    e.stopPropagation();
                    viewProfilePic(patient);
                  }}
                  className="text-center"
                >
                  <img
                    className="rounded-circle user-img"
                    src={patient.profilePicOri}
                    alt="user-img"
                  />
                </td>
                <td>
                  <div className="d-flex flex-column">
                    <p className="mb-0">
                      <b>{patient.fullName}</b>
                    </p>
                    <a
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      className="high-z-index list-email"
                      href={"mailto:" + patient.email}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {patient.email?.replaceAll("#", "")}
                    </a>
                    <p className="mb-0">
                      <ICPhoneDisplay value={patient.phoneNumber} />
                    </p>
                  </div>
                </td>
                <td>{patient.dateOfBirth}</td>
                <td>{patient.gender}</td>
                <td>
                  <div className="d-flex flex-row align-items-center justify-content-center pt-2">
                    {patient.isBlocked && patient.isDependent ? (
                      <i className="fas fa-users dependent-icon"></i>
                    ) : (patient.isBlocked ? (
                      <button
                        onClick={e => {
                          e.stopPropagation();
                          unblockPat(patient);
                        }}
                        type="button"
                        className="btn btn-out-delete high-z-index"
                      >
                        <i className="fas fa-lock"></i>
                      </button>
                    ) : "")}
                    {!patient.isBlocked && (
                      <button
                        onClick={e => {
                          e.stopPropagation();
                          blockPat(patient);
                        }}
                        type="button"
                        className="btn btn-out-green high-z-index"
                      >
                        <i className="fas fa-lock-open"></i>
                      </button>
                    )}
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        sendNotification(patient);
                      }}
                      type="button"
                      className="btn btn-out-bell high-z-index ml-2"
                    >
                      <i className="fas fa-bell"></i>
                    </button>
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        deletePat(patient);
                      }}
                      type="button"
                      className="btn btn-out-delete high-z-index ml-2"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                  {/* <p
                    onClick={e => {
                      e.stopPropagation();
                      viewPatBlockedDoc(patient);
                    }}
                    className="text-center mt-3 blocked-doctor-link"
                  >
                    View Blocked Doctors
                  </p> */}
                </td>
              </tr>
            ))}
        </CustomDataTable>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams1} />
        {/*<MakeAPICall apiParam={apiCallParams2} />*/}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(PatientsPage);
